import gql from "graphql-tag";
import {useMutation} from "@apollo/react-hooks";
import React, {useContext} from "react";
import {OrgDataContext} from "../../../context/orgData";
import {FlightNode} from "../../../__generated__/graphql/types";
import {Button, Col, message, Popover, Row, Switch, Typography} from "antd";
import moment from "moment";
import {useApolloClient} from "react-apollo";
import {useEventTrigger} from "context/event-context";

const MUTATION = gql`
    mutation WeatherDeplayPopupHelper_UpdateFlight($payload: FlightNodeInput!, $orgID: ID!){
        setFlight(payload: $payload, orgID: $orgID) {
            _id
            weatherDelayTs
        }
    }
`

type FlightRecord = Pick<FlightNode, '_id' | 'weatherDelayTs' | 'state'>

function useWeatherDelay(record: FlightRecord){
    const client = useApolloClient();
    const [ mutate, { loading } ] = useMutation(MUTATION);
    const orgData = useContext(OrgDataContext);
    const trigger = useEventTrigger();

    const flight = client.readFragment({
        id: 'FlightNode:' + record._id,
        fragment: gql`
            fragment WeatherDelayFragment on FlightNode {
                _id
                weatherDelayTs
                state
            }
        `,
        fragmentName: 'WeatherDelayFragment'
    }) as FlightRecord | null;

    function set(setWeatherDelay: boolean){

        const payload = {
            _id: record._id,
            setWeatherDelay: setWeatherDelay
        };

        mutate({
            variables: {
                payload: payload,
                orgID: orgData.getActiveOrgID()
            }
        })
            .then(({ data }) => {
                message.success("Weather delay status updated");
                trigger("flight.weatherDelayUpdated", data.setFlight); // Named trigger for live flights refresh
            })
            .catch(err => {
                console.error("Failed to update weather delay status", err);
                message.error("Failed to update weather delay status");
            });
    }

    return {
        loading,
        value: !!flight?.weatherDelayTs,
        set,
    }
}

export default function WeatherDelayPopupHelper({ record } : { record: FlightRecord }){
    const { loading, set, value } = useWeatherDelay(record);

    let component: React.ReactNode = "N/A";

    if (record.weatherDelayTs){
        const ts = moment.tz(record.weatherDelayTs, 'America/Chicago').format('HH:mm');

        component = <div style={{ position: 'relative', width: '6rem', display: 'inline-block' }}>
            <div style={{ position: 'absolute', top: '-1.5rem', left: '25%' }}>
                <Typography.Text type="warning">DELAY</Typography.Text>
            </div>
            <div style={{ position: 'absolute', top: '-0.5rem' }}>As of {ts} CST</div>
        </div>
    }

    const popoverContent = (
        <div>
            <Row>
                <Col sm={12}>
                    Delayed:
                </Col>
                <Col sm={12}>
                    <Switch
                        size="small"
                        checked={value}
                        loading={loading}
                        onChange={set}
                    />
                </Col>
            </Row>
        </div>
    )

    let editButton: React.ReactNode = null;

    if (record.state !== 'DEPARTED' && record.state !== 'LOCKED') {
        editButton = <Popover title="Edit weather delay status" content={popoverContent} trigger="click">
            <Button size="small" icon="edit" style={{marginLeft: 6}} className="mc-btn-transparent"/>
        </Popover>
    }

    return <>
        {component}
        {editButton}
    </>
}